import { ARROWS } from '../constants/arrows';
import { SortByField } from '../models/internal/sort-by-field';

export class SortingConfiguration {
  private sortByField?: SortByField;

  public get SortByField(): SortByField | undefined {
    return this.sortByField;
  }

  constructor(defualtField?: string) {
    if (defualtField) {
      this.sortBy(defualtField);
    }
  }

  public sortBy(field: string): SortByField {
    if (!this.sortByField) {
      this.sortByField = { field, orderByDescending: false };
    } else if (this.sortByField.field === field) {
      this.sortByField.orderByDescending = !this.sortByField.orderByDescending;
    } else {
      this.sortByField = { field, orderByDescending: false };
    }
    return this.sortByField;
  }

  public isOrderByDescending(field: string): boolean {
    return this.sortByField?.field === field && this.sortByField?.orderByDescending === true;
  }

  public setSortByField(sortByField: SortByField): void {
    this.sortByField = sortByField;
  }

  public isSortedByOtherField(field: string): boolean {
    return !this.sortByField || this.sortByField.field !== field;
  }

  public getArrowDirection(field: string): string {
    if (this.isSortedByOtherField(field)) {
      return ARROWS.BOTH;
    } else {
      return this.isOrderByDescending(field) ? ARROWS.DOWN : ARROWS.UP;
    }
  }
}
